import React from 'react';
import { useIntl } from 'react-intl';
import Grid from '@mui/material/Grid';
import { useT } from '@transifex/react';
import { Typography } from '@raisin/components-lib';
import messages from '../../messages';

export interface BankOffersListHeaderProps {
  hasNoticeOffers: boolean;
}

const BankOffersListHeader: React.FC<BankOffersListHeaderProps> = ({ hasNoticeOffers = false }) => {
  const t = useT();
  const { locale } = useIntl();
  const isGBR = locale === 'en-GB';

  return (
    <Grid container sx={{ justifyContent: 'space-between' }} pt={2} pb={2}>
      <Grid item sm={2}>
        <Typography variant="body1" color="grey700">
          {t(messages.bankOffersListItemRate)}
        </Typography>
      </Grid>
      <Grid item sm={2}>
        <Typography variant="body1" color="grey700">
          {hasNoticeOffers
            ? t(messages.bankOffersListItemDurationAndNoticePeriod)
            : t(messages.bankOffersListItemDuration)}
        </Typography>
      </Grid>
      {isGBR ? (
        <Grid item sm={2}>
          <Typography variant="body1" color="grey700">
            {t(messages.bankOffersListItemDepositGuarantee)}
          </Typography>
        </Grid>
      ) : (
        <Grid item sm={2}>
          <Typography variant="body1" color="grey700">
            {t(messages.bankOffersListItemCurrency)}
          </Typography>
        </Grid>
      )}
      <Grid item sm={2}>
        <Typography variant="body1" color="grey700">
          {t(messages.bankOffersListItemProductType)}
        </Typography>
      </Grid>

      <Grid item sm={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}></Grid>
    </Grid>
  );
};

export default BankOffersListHeader;
